<template>
  <div>
    <DeletePageDialog
      v-if="isOpen"
      :pageDetails="{ micrositeId, id }"
      :isOpen="isOpen"
      @close="closeDialog"
    />
    <ErrorButton class="ml-2" dense shrink light @click.native="openDialog">
      Delete <v-icon>mdi-close</v-icon>
    </ErrorButton>
  </div>
</template>

<script>
import DeletePageDialog from "@/views/settings/components/microsites/components/dialogs/DeletePageDialog";
import ErrorButton from "@/components/common/Button/ErrorButton";

export default {
  props: {
    micrositeId: String,
    id: String
  },
  components: {
    DeletePageDialog,
    ErrorButton
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
